import '../styles/index.css';
import type { ReactNode } from 'react';

export interface GameScreenProps {
  children: ReactNode;
  className?: string;
}

export function GameScreen({ children, className }: GameScreenProps) {
  const containerClass = ['pawa-game-container', className].filter(Boolean).join(' ');

  return (
    <div className={containerClass}>
      <div className="pawa-game-content">{children}</div>
    </div>
  );
}
